import Abstract from "../../../abstract-view/abstract.js";

import {
  createElement
} from "../../../render/render.js";

import {
  declinationNumber
} from "../../../../utils/declination-number.js";

import {
  QUANTITY_UNIT_MEASURE
} from "../../lexicon.js";

const createTotalTemplate = (total) => {
  return (
    `<sup class="category-products-quantity" style="opacity: 0;">${total}&nbsp;${declinationNumber(total, QUANTITY_UNIT_MEASURE)}</sup>`
  );
};

export default class HeadingWrapper extends Abstract {
  constructor(element) {
    super();

    this._element = element;
    this._headingElemet = null;
    this._totalElement = null;
  }

  createTotalElement(total) {
    if (!this._totalElement) {
      this._totalElement = createElement(this._getTotalTemplate(total));
    }

    return this._totalElement;
  }

  getHeadingElement() {
    if (!this._headingElement) {
      this._headingElement = this._element.querySelector(`.heading_h1`);
    }

    return this._headingElement;
  }

  getTotalElement() {
    if (!this._totalElement) {
      this._totalElement = this._element.querySelector(`.category-products-quantity`);
    }

    return this._totalElement;
  }

  getTotal() {
    return (this.getTotalElement()) ?
      +this.getTotalElement().textContent.replace(/[^\d]/ig, ``) :
      null;
  }

  unsetTotalElement() {
    this._totalElement = null;
  }

  changeTotal(total) {
    if (this.getTotalElement()) {
      this.getTotalElement().textContent = `${total} ${declinationNumber(total, QUANTITY_UNIT_MEASURE)}`;
    }
  }

  makeTotalVisible() {
    if (this.getTotalElement()) {
      this.getTotalElement().style.opacity = null;
    }
  }

  _getTotalTemplate(total) {
    return createTotalTemplate(total);
  }
}
